<!-- 个人中心 -->
<template>
  <div style="background-image: linear-gradient(to bottom, #CCE7FF,5%,#f9f9f9);padding-top: 80px;">
    <!-- 行业 -->
    <div class="shade-unify" v-if="isindustry==true"></div>
    <div class="hotss-unify" v-if="isindustry==true" style="z-index: 999;position: fixed;left: 0;right: 0;height: 500px">
      <div class="hots-titles-unify" style="overflow: hidden;padding-top: 25px;">
        <div style="float: left;">请选择职位类别</div>
        <img style="float: right;width: 24px;height: 24px;margin-right: 16px;cursor: pointer" src="../../assets/close.png" @click="close()" alt="">
      </div>
      <div class="hots-contents-unify">
        <div class="hots-left-unify">
          <div v-for="(item,index) in tradeList" class="hots-left-label-unify" :key="index" @mouseenter="changePosition(index)">
            <div :class="index==tradeListIndex ? 'active' : ''">{{item.name}}</div>
          </div>
        </div>
        <div class="hots-right-unify">
          <div class="hots-right-box-unify">
            <div class="hots-right-cont-unify">
              <div style="padding: 5px 10px;border-radius: 4px;background-color: #F1F2F6;" v-for="(item,index) in tradeList[tradeListIndex].list" :key="index" @click="chooseTrade(item.id,item.name)">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    行业-->
    <div class="personalCore-box">
      <div class="personalCore-left">
        <div class="personalCore-search-left">
          <div class="personalCore-search-int">
            <input type="text" v-model="keywords" placeholder="搜索职位/公司/内容关键词" />
            <div @click="searchs()">搜索</div>
          </div>
          <div class="personalCore-search-history">
            <div>热搜：</div>
            <div v-for="(item, index) in jobList" :key="index" @click="searchs(item)">{{item}}</div>
          </div>
        </div>
        <!-- 筛选条件 -->
        <div class="search-condition" style="width: 860px;margin-bottom: 31px">
          <div class="search-conditions" style="margin-top: 41px;" :style="{'height' : ismore == false ? '20px' : '150px'}">
            <div class="search-conditions-title" :style="{'height' : ismore == false ? '20px' : '150px'}">所在区域</div>
            <div class="search-conditions-factor" v-for="(item,index) in provinceList" :key="index" @click="searchCity(item.id, index, item.name)">
              <div class="search-conditions-factor-title" :class="cityIndex==index?'search-conditions-title-active':''" :style="{'margin-bottom' : ismore == false ? '0' : '10px'}">{{item.name}}</div>
            </div>
            <div v-if="ismore==false" style="float: left;font-size: 14px;color: #587CF7;cursor: pointer;" @click="moreCity()">更多</div>
            <div v-if="ismore==true" style="float: left;font-size: 14px;color: #587CF7;cursor: pointer;" @click="moreCity()">收起</div>
          </div>
          <div class="search-mores">
            <div class="search-conditions-title">薪资待遇</div>
            <div class="search-conditions-factor">
              <el-dropdown @command="searchSalary" style="width: 137px;height: 26px;line-height: 26px;border: 1px solid #D3D3D3;background-color: #fff;border-radius: 8px;float: left;margin-right: 13px">
                <span class="el-dropdown-link" style="padding-right: 38px;">
                  {{salary}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu class="project-dropdown eldown-menu-persinalCoreVue" slot="dropdown" style="width: 137px">
                  <el-dropdown-item v-for="(item,index) in salaryList" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <div style="display:inline;height: 26px;line-height: 26px;border: 1px solid #D3D3D3;background-color: #fff;border-radius: 8px;width: 130px;float: left;margin-right: 13px">
                <div class="el-dropdown-link" @click="selectIndustry()">
                  <div style="height: 28px;line-height: 28px;width: 113px;color:#2E2E2E;font-size: 12px;position: relative" >
                    <div style="float: left;width: 80px;text-wrap: nowrap;overflow: hidden;text-overflow: ellipsis;">{{industry}}</div>
                    <i class="el-icon-arrow-down el-icon--right" style="position: absolute"></i></div>
                </div>
              </div>
<!--              <el-dropdown @command="handleIndustry" style="width: 137px;height: 26px;line-height: 26px;border: 1px solid #D3D3D3;background-color: #fff;border-radius: 8px">-->
<!--                <span class="el-dropdown-link" style="padding-right: 38px;">-->
<!--                  {{industry}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--                </span>-->
<!--                <el-dropdown-menu slot="dropdown" class="project-dropdown eldown-menu-persinalCoreVue" style="width: 220px">-->
<!--                  <el-dropdown-item v-for="(item,index) in tradeList" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{item.name}}</el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
              <el-dropdown @command="handleEducation" style="width: 137px;height: 26px;line-height: 26px;border: 1px solid #D3D3D3;background-color: #fff;border-radius: 8px;float: left">
                <span class="el-dropdown-link" style="padding-right: 38px;">
                  {{education}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu class="project-dropdown eldown-menu-persinalCoreVue" slot="dropdown"  style="width: 137px">
                  <el-dropdown-item v-for="(item,index) in eduList" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="search-selected" v-if="searchCondition!==undefined&&searchCondition.length > 0">
            <div class="search-selected-title-personalCoreVue">已筛选条件：</div>
            <div class="search-selected-factor-personalCoreVue">
              <div class="search-selected-factor-box-personalCoreVue" v-for="(item, index) in searchCondition" :key="index" @click="deleteCondition(item)">
                <div>{{item}}</div>
                <img src="../../assets/search-close.png" alt="" />
              </div>
              <div @click="empty()" style="float: right;color: #027FFE;font-size: 14px;cursor: pointer;">清空筛选条件</div>
            </div>
          </div>
        </div>
        <!-- 筛选条件 -->
        <div class="personalCore-left-title">最新职位推荐</div>
        <div class="personalCore-left-list" style="float: left;">
          <div class="search-company" v-if="companyList !== undefined && companyList.length > 0">
            <img :src="companyList[0].logoUrl" />
            <div class="search-company-details">
              <div class="search-company-name">{{companyList[0].name}}</div>
              <div class="search-company-tabel">
                <div>{{companyList[0].nature}}</div>
                <div>{{companyList[0].trade}}</div>
                <div>{{companyList[0].scale}}</div>
              </div>
            </div>
          </div>
          <!-- 原版修改2023-4-24-->
          <div v-if="jobInfoList!==undefined&&jobInfoList.length > 0">
            <div class="enterpriseDetails-jobboxs" style="margin-bottom: 22px;" v-for="(item,index) in jobInfoList" :key="index" @click="jobDetails(item.id)">
              <div style="margin: 0 24px;padding: 16px 0 24px 0;border-bottom: 1px dashed #D9D9D9">
                <div class="enterpriseDetails-jobboxs-name">
                  <div class="enterpriseDetails-jobboxs-name-l1">{{item.name}}</div>
                  <div class="enterpriseDetails-jobboxs-name-l2">【{{item.address3}}】</div>
                  <div class="enterpriseDetails-jobboxs-names">
                    <img v-if="item.companyInfo[0].logo!==''" :src="item.companyInfo[0].logo" alt="">
                    <img v-if="item.companyInfo[0].logo===''" src="../../assets/ping.png" alt="">
                    <div>{{item.companyInfo[0].name}}</div>
                  </div>
                </div>
                <div class="enterpriseDetails-jobboxs-com" style="height: 26px;line-height: 26px;">
<!--                  <div v-if="item.salary!==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salary}}-{{item.salaryEnd}}/月</div>
                  <div v-if="item.salary==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salaryEnd}}元以下</div>
                  <div v-if="item.salaryEnd==undefined&&item.salary!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salary}}元以上</div>
                  <div v-if="item.isSalary==2" class="enterpriseDetails-jobboxs-wages">面议</div>-->
                  <div v-if="item.salaryName!==undefined&&item.salaryName!==null" class="enterpriseDetails-jobboxs-wages">{{item.salaryName}}</div>
                  <div class="enterpriseDetails-jobboxs-years">{{item.eduName}}</div>
                  <div class="enterpriseDetails-jobboxs-educational">{{ item.workName }}</div>
                  <div class="enterpriseDetails-jobboxs-label">
                    <div style="max-width: 56px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].nature}}</div>
                    <div style="max-width: 96px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].trade}}</div>
                    <div style="max-width: 86px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].scale}}</div>
                  </div>
                </div>
              </div>
              <div class="enterpriseDetails-jobboxs-demand">
                <div class="enterpriseDetails-jobboxs-demands">
                  <div v-for="(items, indexs) in item.tagList" :key="indexs" v-if="indexs<5" >{{items.title}}</div>
                </div>
                <!-- <div style="float: right;width: 270px;">
                  <div style="font-size: 12px;color: #979797;text-align: right;margin-right: 24px;line-height: 22px">发布时间：{{item.updateTime}}</div>
                </div> -->
              </div>
            </div>
            <!-- 原版修改2023-4-24-->

            <el-pagination :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background layout="prev, pager, next" :total="totalNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
          <div v-else style="text-align: center;">
            <img style="margin-top: 100px;margin-bottom: 10px;" src="../../assets/searchEmpty.png" alt="">
            <div style="font-size: 14px;color: #9C9C9C;">暂无岗位</div>
          </div>
        </div>

      </div>
      <!-- 个人信息 -->
      <div class="personalCore-right">
        <div class="personalCore-right-info-personalCoreVue">
          <img :src="userInfo.userPhoto" />
          <div class="personalCore-right-info-div-box-personalCoreVue">
            <div style="font-weight: bold">{{userInfo.userName}}</div>
            <div style="margin-top: 13px;font-size: 16px;color: #3D3D3D">
              <span v-if="userInfo.age !=='' && userInfo.age !== undefined">{{ userInfo.age }}岁</span>
              <span v-if="userInfo.age !=='' && userInfo.age !== undefined && userInfo.edu !=='' && userInfo.edu !== undefined">|</span>
              <span v-if="userInfo.edu">{{ userInfo.edu }}</span>
              <span v-if="userInfo.edu !=='' && userInfo.edu !== undefined && userInfo.condition !=='' && userInfo.condition !== undefined">|</span>
              <span v-if="userInfo.condition">{{ userInfo.condition }}</span>
            </div>
          </div>
        </div>
        <div class="personalCore-right-box">
          <div style="display: flex;padding: 24px 31px 20px;">
            <div class="personalCore-right-boxs-personalCoreVue" @click="resume()" style="margin-right: 24px;">
              <img src="../../assets/personalCore-icon4.png" />
              <div>个人简历</div>
            </div>
            <div class="personalCore-right-boxs-personalCoreVue" @click="enroll()">
              <img src="../../assets/personalCore-icon2.png" />
              <div>我的投递</div>
            </div>
          </div>
          <div style="display: flex;padding: 0px 31px 35px;">
            <div class="personalCore-right-boxs-personalCoreVue" @click="go()" style="margin-right: 24px;">
              <img src="../../assets/personalCore-icon3.png"/>
              <div>我的收藏</div>
            </div>
            <div class="personalCore-right-boxs-personalCoreVue" @click="lookMe()" >
              <img src="../../assets/personalCore-icon1.png"/>
              <div>查看我的</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 个人信息 -->
    </div>
  </div>
</template>

<script>
import request from '../../util/request'

export default {
  data () {
    return {
      jobInfoList: [],
      companyList: [],
      pageSize: 30,
      pageNum: 1,
      totalNum: 0,
      keywords: '',
      jobList: [],
      userInfo: {},
      searchCondition: [],
      provinceList: [],
      salaryList: [],
      tradeList: [],
      eduList: [],
      cityIndex: -1,
      provinceId: '',
      education: '学历',
      eduId: '',
      industry: '行业',
      tradeId: '',
      salary: '薪资待遇',
      salaryId: '',
      salaryListValue: '',
      provinceName: '',
      ismore: false,
      isindustry: false,
      tradeListIndex: 0
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getList()
      this.getData()
      this.getDatas()
    })
  },
  mounted () {

  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/searchJobList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.jobList = res.data.data.jobList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取筛选条件
    getDatas () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/getSelectList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.selectList = res.data.data.selectList
          res.data.data.selectList.forEach(function (item, index) {
            if (item.name === '工作地区') {
              that.provinceList = item.list
              that.provinceList = that.provinceList.slice(0, 8)
              // console.log(that.provinceList)
            }
            if (item.name === '薪资') {
              that.salaryList = item.list
            }
            if (item.name === '学历') {
              that.eduList = item.list
            }
            if (item.name === '行业') {
              that.tradeList = item.list
            }
          })
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/searchJobList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.jobList = res.data.data.jobList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getList () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: localStorage.getItem('token')
        },
        url: `/web/index/list`,
        data: JSON.stringify({
          keywords: '',
          pageSize: that.pageSize,
          pageNum: that.pageNum,
          Bearer: localStorage.getItem('token')
        })
      }).then(
        (res) => {
          that.jobInfoList = res.data.data.jobInfoList
          that.totalNum = res.data.data.totalNum
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    moreCity () {
      var that = this
      if (that.ismore === false) {
        that.selectList.forEach(function (item, index) {
          if (item.name === '工作地区') {
            that.provinceList = item.list
            that.ismore = true
          }
        })
      } else {
        that.selectList.forEach(function (item, index) {
          if (item.name === '工作地区') {
            that.provinceList = item.list
            that.provinceList = that.provinceList.slice(0, 8)
            that.ismore = false
          }
        })
      }
    },
    beforeHandleCommand (name, id) {
      return {
        id: id,
        name: name
      }
    },
    // 筛选条件-城市
    searchCity (e, i, name) {
      var that = this
      that.provinceId = e
      that.cityIndex = i
      if (that.provinceName !== '') {
        let index = that.searchCondition.findIndex(item => {
          if (item === that.provinceName) {
            return true
          }
        })
        that.searchCondition.splice(index, 1)
        that.provinceName = name
        that.searchCondition.push(that.provinceName)
        that.searchCondition = that.searchCondition
        console.log(that.searchCondition)
      } else {
        that.provinceName = name
        that.searchCondition.push(that.provinceName)
        that.searchCondition = that.searchCondition
      }
      that.searchs()
    },
    // 筛选条件-薪资
    searchSalary (command) {
      var that = this
      that.salaryId = command.id
      if (that.salary !== '薪资待遇') {
        let index = that.searchCondition.findIndex(item => {
          if (item === that.salary) {
            return true
          }
        })
        that.searchCondition.splice(index, 1)
        that.salary = command.name
        that.searchCondition.push(that.salary)
        that.searchCondition = that.searchCondition
      } else {
        that.salary = command.name
        that.searchCondition.push(that.salary)
        that.searchCondition = that.searchCondition
      }
      that.searchs()
    },
    // 筛选条件-学历
    handleEducation (command) {
      var that = this
      that.eduId = command.id
      if (that.education !== '学历') {
        let index = that.searchCondition.findIndex(item => {
          if (item === that.education) {
            return true
          }
        })
        that.searchCondition.splice(index, 1)
        that.education = command.name
        that.searchCondition.push(that.education)
        that.searchCondition = that.searchCondition
      } else {
        that.education = command.name
        that.searchCondition.push(that.education)
        that.searchCondition = that.searchCondition
      }
      that.searchs()
    },
    // 筛选条件-行业
    handleIndustry (command) {
      var that = this
      that.tradeId = command.id
      if (that.industry !== '行业') {
        let index = that.searchCondition.findIndex(item => {
          if (item === that.industry) {
            return true
          }
        })
        that.searchCondition.splice(index, 1)
        that.industry = command.name
        that.searchCondition.push(that.industry)
        that.searchCondition = that.searchCondition
      } else {
        that.industry = command.name
        that.searchCondition.push(that.industry)
        that.searchCondition = that.searchCondition
      }
      that.searchs()
    },
    empty () {
      var that = this
      that.searchCondition = []
      if (that.provinceName !== '') {
        that.provinceName = ''
        that.provinceId = ''
        that.cityIndex = -1
      }
      if (that.salary !== '') {
        that.salary = '薪资待遇'
        that.salaryId = ''
        that.salaryIndex = -1
      }
      if (that.education !== '') {
        that.education = '学历'
        that.eduId = ''
      }
      if (that.industry !== '') {
        that.industry = '行业'
        that.tradeId = ''
      }
      that.searchs()
    },
    searchs (e) {
      if (e) {
        this.keywords = e
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/list`,
        data: JSON.stringify({
          keywords: this.keywords,
          province: this.provinceId,
          salary: this.salaryId,
          edu: this.eduId,
          trade: this.tradeId,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        })
      }).then(
        (res) => {
          this.jobInfoList = res.data.data.jobInfoList
          this.companyList = res.data.data.companyList
          this.totalNum = res.data.data.totalNum
        },
        (err) => {
          this.$message.error(err)
        }
      )
    },
    jobDetails (id) {
      this.$router.push({
        path: '/jobDetails',
        query: {
          id: id
        }
      })
    },
    resume () {
      if (this.userInfo.isResume === false) {
        this.$router.push({ path: '/EditResume' })
      } else {
        this.$router.push({ path: '/resume' })
      }
    },
    go () { // 去收藏
      // this.$router.push({ path: '/myCollection' })
      this.$router.push({path: '/myEnroll', query: { change: '2' }})
    },
    enroll () {
      this.$router.push({ path: '/myEnroll' })
    },
    lookMe () {
      this.$router.push({path: '/myEnroll', query: { change: '3' }})
    },
    // 分页
    handleSizeChange (val) {
      this.pageNum = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getList()
    },
    // 删除条件
    deleteCondition (name) {
      var that = this
      let index = that.searchCondition.findIndex(item => {
        if (item === name) {
          return true
        }
      })
      that.searchCondition.splice(index, 1)
      if (name === that.provinceName) {
        that.provinceName = ''
        that.provinceId = ''
        that.cityIndex = -1
        that.searchs()
      }
      if (name === that.salary) {
        that.salary = '薪资待遇'
        that.salaryId = ''
        that.searchs()
      }
      if (name === that.education) {
        that.education = '学历'
        that.eduId = ''
        that.searchs()
      }
      if (name === that.industry) {
        that.industry = '行业'
        that.tradeId = ''
        that.searchs()
      }
    },
    changePosition (e) {
      this.tradeListIndex = e
      // this.freshKey = new Date().getTime()
    },
    // 行业
    selectIndustry () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/tradeList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.tradeList = res.data.data.tradeList
          that.isindustry = true
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    chooseTrade (id, name) {
      var that = this
      that.trade = name
      // that.trade = that.tradeList[this.tradeListIndex].name
      that.tradeId = id
      // that.tradeId = that.tradeList[this.tradeListIndex].id
      that.isindustry = false
      /* 2023119新增 */
      if (that.industry !== '行业') {
        let index = that.searchCondition.findIndex(item => {
          if (item === that.industry) {
            return true
          }
        })
        that.searchCondition.splice(index, 1)
        that.industry = that.trade
        that.searchCondition.push(that.industry)
        that.searchCondition = that.searchCondition
      } else {
        that.industry = that.trade
        that.searchCondition.push(that.industry)
        that.searchCondition = that.searchCondition
      }
      that.searchs()
      /* 2023119新增 */
    },
    close () {
      this.isindustry = false
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
.personalCore-box{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 27px;
}
.personalCore-left{
  width: 860px;
  float: left;
  margin-right: 20px;
}
.personalCore-left-title{
  color: #0C0C0C;
  font-size: 20px;
  font-weight: 550;
  margin-bottom: 20px;
}
.personalCore-left-list{
  float: left;
  width: 860px;
}
.personalCore-search-left{
  /*float: left;*/
  width: 788px;
  margin-bottom: 53px;
}
.personalCore-search-int{
  overflow: hidden;
  background-color: #fff;
  border-radius: 26px;
  width: 785px;
  height: 52px;
  line-height: 52px;
}
.personalCore-search-int input{
  float: left;
  font-size: 14px;
  color: #585555;
  height: 52px;
  line-height: 52px;
  width: 676px;
  border: none;
  outline-style: none;
  padding-left: 18px;
  border-radius: 26px;
  padding-right: 91px;
}
.personalCore-search-int div{
  float: right;
  height: 40px;
  line-height: 40px;
  margin-top: 6px;
  margin-right: 9px;
  background-color: #587CF7;
  color: #fff;
  width: 82px;
  border-radius: 20px;
  text-align: center;
  font-size: 16px;
  margin-left: -91px;
  cursor: pointer;
}
.personalCore-search-history{
  overflow: hidden;
  margin-top: 17px;
}
.personalCore-search-history div{
  float: left;
  font-size: 14px;
  color: #3E4968;
  margin-left: 10px;
  cursor: pointer;
}
.personalCore-joblist{
  width: 788px;
  margin-right: 9px;
  margin-bottom: 16px;
  cursor: pointer;
}
.personalCore-jobboxs{
  width: 788px;
  height: 122px;
  background-color: #ffff;
  border-radius: 5px;
}
.personalCore-jobboxs-name{
  overflow: hidden;
  margin-bottom: 12px;
}
.personalCore-jobboxs-name div:first-child{
  float: left;
  margin-left: 24px;
  margin-top: 16px;
  margin-right: 13px;
  font-size: 18px;
  font-weight: 550;
}
.personalCore-jobboxs-name div:last-child{
  float: left;
  margin-top: 16px;
  font-size: 14px;
}
.personalCore-jobboxs-demand{
  overflow: hidden;
  margin-bottom: 12px;
}
.personalCore-jobboxs-demands{
  float: left;
  overflow: hidden;
  margin-left: 24px;
  width: 600px;
  height: 30px;
}
.personalCore-jobboxs-demands div{
  float: left;
  padding: 2px 20px;
  border: 1px solid #0091FF;
  border-radius: 5px;
  font-size: 12px;
  margin-right: 16px;
  color: #027FFE;
  margin-bottom: 8px;
}
.personalCore-jobboxs-wages{
  float: right;
  margin-right: 31px;
  color: #FF8C41;
  font-size: 18px;
  font-weight: 600;
}
.personalCore-jobboxs-com{
  overflow: hidden;
}
.personalCore-jobboxs-names{
  float: left;
  overflow: hidden;
  margin-left: 24px;
  margin-right: 32px;
}
.personalCore-jobboxs-names img{
  float: left;
  width: 18px;
  height: 18px;
}
.personalCore-jobboxs-names div{
  float: left;
  font-size: 14px;
}
.personalCore-jobboxs-label{
  float: left;
  overflow: hidden;
}
.personalCore-jobboxs-label div{
  float: left;
  font-size: 14px;
  color: #818181;
  margin-right: 32px;
}
.personalCore-right{
  width: 307px;
  float: left;
  height: 421px;
  background-color: #fff;
  border-radius: 10px;
}
.personalCore-right-info-personalCoreVue{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCore-right-info-personalCoreVue img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 30px;
  border-radius: 37.5px;
}
.personalCore-right-info-div-box-personalCoreVue{
  float: left;
  margin-top: 34px;
  font-size: 18px;
}
.personalCore-right-box{
  width: 100%;
}
.personalCore-right-boxs-personalCoreVue{
  position: relative;
  cursor: pointer;
}
.personalCore-right-boxs-personalCoreVue img{
  width: 110px;
  height: 110px;
}
.personalCore-right-boxs-personalCoreVue div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  text-align: center;
  margin-bottom: 28px;
}
/*2023-4-24*/
.enterpriseDetails-jobboxs{
  width: 860px;
  /*height: 122px;*/
  height: 153px;
  background-color: #ffff;
  border-radius: 5px;
}
.enterpriseDetails-jobboxs-name{
  height: 26px;line-height: 26px;margin-bottom: 16px
}
.enterpriseDetails-jobboxs-name-l1{
  float: left;font-size: 18px;font-weight: bold;margin-right: 14px;
}
.enterpriseDetails-jobboxs-name-l2{
  float: left;font-size: 14px;
}
.enterpriseDetails-jobboxs-names{
  float: right;width: 270px;
}
.enterpriseDetails-jobboxs-names img{
  float: left;
  width: 18px;
  height: 15px;
  margin-top: 4px;
  margin-right: 5px;
}
.enterpriseDetails-jobboxs-names div{
  /*float: left;*/
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.enterpriseDetails-jobboxs-com{
  overflow: hidden;
}
.enterpriseDetails-jobboxs-wages{
  margin-right: 31px;color: #FF8C41;font-size: 18px;font-weight: 600;float: left;
}
.enterpriseDetails-jobboxs-educational,.enterpriseDetails-jobboxs-years{
  float: left;font-size: 14px;color: #818181;margin-right: 12px;
}
.enterpriseDetails-jobboxs-label{
  float: right;width: 270px;
}
.enterpriseDetails-jobboxs-label div{
  float: left;
  font-size: 14px;
  color: #818181;
  margin-right: 12px;
}
.enterpriseDetails-jobboxs-label div:last-child{
  margin-right: 0;
}
.enterpriseDetails-jobboxs-demand{
  overflow: hidden;
  margin-bottom: 12px;
  margin-top: 10px;
}
.enterpriseDetails-jobboxs-demands{
  float: left;
  overflow: hidden;
  margin-left: 24px;
}
.enterpriseDetails-jobboxs-demands div{
  float: left;
  padding: 2px 20px;
  border: 1px solid #0091FF;
  border-radius: 5px;
  font-size: 12px;
  margin-right: 16px;
  color: #027FFE;
}
.search-conditions-title{
  float: left;
  margin-right: 28px;
  font-size: 14px;
  font-weight: 550;
}
.search-conditions-title-active{
  color: #027FFE;
  font-weight: 550;
}
/* 筛选条件 */
.search-condition{
  width: 1200px;
  background-color: #fff;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 34px;
  overflow: hidden;
  padding-bottom: 20px;
}
.search-conditions{
  display: block;
  overflow: hidden;
  margin-left: 25px;
  margin-bottom: 28px;
  height: 20px;
}
.search-conditions-title{
  float: left;
  margin-right: 28px;
  font-size: 14px;
  font-weight: 550;
}
.search-conditions-factor{
  float: left;
  overflow: hidden;
  cursor: pointer;
}
.search-conditions-factor-title{
  float: left;
  font-size: 14px;
  margin-right: 34px;
  color: #484141;
}
.search-conditions-title-active{
  color: #027FFE;
  font-weight: 550;
}
.search-mores{
  display: block;
  margin-left: 25px;
  overflow: hidden;
}

.search-selected{
  display: block;
  overflow: hidden;
  margin-top: 21px;
  margin-left: 25px;
}
.search-selected-title-personalCoreVue{
  float: left;
  margin-right: 5px;
  font-size: 14px;
  margin-top: 2px;
  font-weight: bold;
}
.search-selected-factor-personalCoreVue{
  float: left;
  margin-right: 13px;
  overflow: hidden;
  width: 85%;
}
.search-selected-factor-box-personalCoreVue{
  overflow: hidden;
  padding: 2px 8px 3px;
  border: 1px solid #027FFE;
  border-radius: 5px;
  cursor: pointer;
  float: left;
  margin-right: 13px;
}
.search-selected-factor-box-personalCoreVue img{
  width: 14px;
  height: 14px;
  float: left;
  margin-top: 3px;
}
.search-selected-factor-box-personalCoreVue div{
  float: left;
  font-size: 14px;
  color: #027FFE;
  margin-right: 7px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #2E2E2E;
  font-size: 12px;
  margin-left: 17px;
  overflow: hidden;
}
.el-icon-arrow-down {
  font-size: 16px;
}
.el-icon--right {
  float: right;
  margin-top: 5px;
  margin-right: 12px;
}
.eldown-menu-persinalCoreVue{
  width: 137px;
}
.project-dropdown{
  height:300px;
  overflow: auto;
  /*position: relative;*/
}
.project-dropdown::-webkit-scrollbar{
  width: 5px;
  height: 5px;
  background-color: #F5F5F5;
}
.project-dropdown::-webkit-scrollbar-track{
  border-radius: 10px;
  background-color: #F5F5F5;
}
.el-dropdown-menu{
  /*display: block !important;*/
  transform-origin:bottom !important;
}
.cheshiUpdown{
  position: relative;
}
.search-company{
  width: 861px;
  height: 122px;
  margin-bottom: 22px;
  background-color: #fff;
  overflow: hidden;
}
.search-company img{
  width: 75px;
  height: 75px;
  float: left;
  margin-top: 23px;
  margin-left: 26px;
  margin-right: 17px;
}
.search-company-details{
  float: left;
  margin-top: 29px;
}
.search-company-name{
  font-size: 16px;
  color: #030303;
  font-weight: 550;
  margin-bottom: 16px;
}
.search-company-tabel{
  overflow: hidden;
}
.search-company-tabel div{
  float: left;
  margin-right: 24px;
  color: #7A7A7A;
  font-size: 14px;
}
/* 行业 */
.hotss-unify{
  width: 1000px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 24px;
  margin-bottom: 20px;
}
.hots-titles-unify{
  font-weight: 550;
  margin-left: 30px;
  padding-top: 14px;
  font-size: 18px;
}
.hots-contents-unify{
  overflow: hidden;
  margin-top: 18px;
}
.hots-left-unify{
  float: left;
  width: 218px;
  margin-right: 30px;
  height: 401px;
  overflow-y: auto;
}
.hots-left-label-unify div{
  color: #868686;
  height: 39px;
  line-height: 39px;
  font-size: 14px;
  padding-left: 40px;
  cursor: pointer;
}
.hots-left-unify .active{
  background-color: #F2F7FF;
  color: #027FFE;
}
.hots-right-box-unify{
  display: inline-block;
}
.hots-right-unify{
  float: left;
  width: 72%;
  font-size: 14px;
  height: 401px;
  margin-bottom: 10px;
  overflow-y:auto;
}
.hots-right-h1-unify{
  text-align: left;
  font-weight: 550;
  font-size: 16px;
  margin-bottom: 18px;
}
/*.hots-right-cont-unify{*/
/*  font-size: 14px;*/
/*  overflow: hidden;*/
/*  float: left;*/
/*}*/
.hots-right-cont-unify{
  float: left;
}
.hots-right-cont-unify div:nth-child(12n){
  margin-bottom: 30px;
}
.hots-right-cont-unify div{
  color: #A1A1A1;
  float: left;
  margin-right: 20px;
  font-size: 14px;
  margin-bottom: 15px;
  cursor: pointer;
  width: 135px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.hots-right-cont-unify div:hover{
  color: #007aff;
  /*text-wrap: wrap;*/
}
.shade-unify{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 998;
}
</style>



// WEBPACK FOOTER //
// src/views/jobSeekers/personalCore.vue